<template>
  <div class="home-view overflow-x-hidden">
    <!-- Hero Section -->
    <HeroSection />

    <!-- Toruk Magic Intro Section -->
    <TorukMagicSection />

    <!-- Solutions Section -->
    <SolutionsSection />

    <!-- Abilities Section -->
    <AbilitiesSection />

    <!-- Solution Focused Section -->
    <SolutionFocusedSection />

    <!-- Brand Value Section -->
    <BrandValueSection />

    <!-- Target Industries Section -->
    <TargetedIndustriesSection />

    <!-- Partner Logos -->
    <PartnerLogos class="bg-[#0f172a] py-8 sm:py-12 md:py-16" />

    <!-- CTA Section -->
    <CTASection />
  </div>
</template>

<script setup lang="ts">
import PartnerLogos from '@/components/common/PartnerLogos.vue'
import CTASection from '@/components/sections/home/CTASection.vue'
import HeroSection from '@/components/sections/home/HeroSection.vue'
import SolutionFocusedSection from '@/components/sections/home/SolutionFocusedSection.vue'
import TorukMagicSection from '@/components/sections/home/TorukMagicSection.vue'
import AbilitiesSection from '@/components/sections/home/AbilitiesSection.vue'
import BrandValueSection from '@/components/sections/home/BrandValueSection.vue'
import SolutionsSection from '@/components/sections/home/SolutionsSection.vue'
import TargetedIndustriesSection from '@/components/sections/home/TargetedIndustriesSection.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { onMounted } from 'vue'

onMounted(() => {
  AOS.init({
    duration: 800,
    once: true,
    offset: 50,
  })
})
</script>

<style scoped>
.shadow-lg {
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.07),
    0 4px 6px -2px rgba(0, 0, 0, 0.03);
}
.shadow-xl {
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
</style>
